<template>
  <el-form
    :model="form"
    ref="form"
    :disabled="disabledForm"
  >
    <div class="row">
      <div class="col-md-3">
        <div class="row">
          <div class="col">
            <el-form-item
              data-filed="true"
              prop="graveOrNonGrave"
              class="material-style">
              <el-checkbox
                v-model="form.graveOrNonGrave"
                @change="updateModelItem( 'graveOrNonGrave')">
                {{L10n('grave-or-non-grave')}}
              </el-checkbox>
            </el-form-item>
          </div>
          <div class="col">
            <el-form-item
              data-filed="true"
              prop="done"
              class="material-style">
              <el-checkbox
                v-model="form.done"
                @change="updateModelItem( 'done')">
                {{L10n('done')}}
              </el-checkbox>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-12">
        <el-form-item
          :label="L10n('non-conformity-nature')"
          prop="nonConformityNatureID"
          class="material-style"
        >
          <select-response
            :model.sync="form.nonConformityNatureID"
            @update:model="updateModelItem( 'nonConformityNatureID')"
            :isLoading="dataSourceNonConformityNature.loading"
            :data="dataSourceNonConformityNature.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-md-2 col-12">
        <el-form-item
          :label="L10n('non-conformity-nature-2')"
          prop="nonConformityNatureID2"
          class="material-style"
        >
          <select-response
            :model.sync="form.nonConformityNatureID2"
            @update:model="updateModelItem( 'nonConformityNatureID2')"
            :isLoading="dataSourceNonConformityNature.loading"
            :data="dataSourceNonConformityNature.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('non-conformity-origin')"
          prop="nonConformityOriginID"
          class="material-style"
        >
          <select-response
            :model.sync="form.nonConformityOriginID"
            @update:model="updateModelItem( 'nonConformityOriginID')"
            :isLoading="dataSourceNonConformityOrigin.loading"
            :data="dataSourceNonConformityOrigin.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-md-2 col-12">
        <el-form-item
          :label="L10n('finding-date')"
          prop="findingDate"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <date-picker
            v-model="form.findingDate"
            @change="updateModelItem( 'findingDate')"
          ></date-picker>
        </el-form-item>
      </div>
    </div>
    <!-- 1 -->
    <div class="row">
      <div class="col-md-6 col-12">
        <el-form-item
          :label="L10n('company')"
          prop="companyID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-company
            :model.sync="form.companyID"
            @update:model="updateModelItem( 'companyID')"
            @on-data-value="(source) => $emit('updateCompany', source)"
            :disabled="disabledForm"
          >
          </select-company>
        </el-form-item>
      </div>
      <div class="col-md-6 col-12">
        <el-form-item
          :label="L10n('origin-dysfunction-company')"
          prop="originDysfunctionCompanyID"
          class="material-style"
        >
          <select-company
            :model.sync="form.originDysfunctionCompanyID"
            @update:model="updateModelItem( 'originDysfunctionCompanyID')"
            :disabled="disabledForm"
          ></select-company>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-sm-6 col-12">
        <el-form-item
          :label="L10n('non-conformity-dysfunction')"
          prop="nonConformityDysfunctionID"
          class="material-style"
        >
          <select-response
            :model.sync="form.nonConformityDysfunctionID"
            @update:model="updateModelItem( 'nonConformityDysfunctionID')"
            :isLoading="dataSourceNonConformityDysfunction.loading"
            :data="dataSourceNonConformityDysfunction.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-md-8 col-sm-6 col-12">
        <el-form-item
          :label="L10n('non-conformity-dysfunction-detail')"
          prop="nonConformityDysfunctionDetailID"
          class="material-style"
        >
          <select-response
            :model.sync="form.nonConformityDysfunctionDetailID"
            @update:model="updateModelItem( 'nonConformityDysfunctionDetailID')"
            :isLoading="dataSourceNonConformityDysfunctionDetail.loading"
            :data="dataSourceNonConformityDysfunctionDetail.records"
          ></select-response>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <el-form-item
          :label="L10n('analyze-description')"
          prop="analyzeDescription"
          class="material-style"
          :rules="getValidationRule('required')">
          <el-input
            type="textarea"
            :rows="2"
            :value="form.analyzeDescription"
            @input="form.analyzeDescription = valueTrimLeft($event)"
            @change="updateModelItem( 'analyzeDescription')"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-12">
        <el-form-item
          data-filed="true"
          prop="immediateProvisions"
          class="material-style">
          <el-checkbox
            v-model="form.immediateProvisions"
            @change="updateModelItem( 'immediateProvisions')">
            {{L10n('immediate-provisions')}}
          </el-checkbox>
        </el-form-item>
        <el-form-item
          :label="L10n('non-conformity-action')"
          prop="nonConformityActionID"
          class="material-style"
        >
          <select-response
            :model.sync="form.nonConformityActionID"
            @update:model="updateModelItem( 'nonConformityActionID')"
            :isLoading="dataSourceNonConformityAction.loading"
            :data="dataSourceNonConformityAction.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('verification-date')"
          prop="verificationDate"
          class="material-style"
        >
          <date-picker
            v-model="form.verificationDate"
            @change="updateModelItem( 'verificationDate')"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('writtenby-employee')"
          prop="writtenbyEmployeeID"
          class="material-style"
        >
          <select-response
            :model.sync="form.writtenbyEmployeeID"
            @update:model="updateModelItem( 'writtenbyEmployeeID')"
            :isLoading="dataSourceEmployee.loading"
            :data="dataSourceEmployee.records"
            :fields="{id: 'id', title: 'name'}"
          ></select-response>
        </el-form-item>
        <el-form-item
          :label="L10n('employee-incharge')"
          prop="employeeInchargeID"
          class="material-style"
        >
          <select-response
            :model.sync="form.employeeInchargeID"
            @update:model="updateModelItem( 'employeeInchargeID')"
            :isLoading="dataSourceEmployee.loading"
            :data="dataSourceEmployee.records"
            :fields="{id: 'id', title: 'name'}"
          ></select-response>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <el-form-item
          :label="L10n('proposition-daction')"
          prop="propositionDaction"
          class="material-style">
          <el-input
            type="textarea"
            :rows="2"
            :value="form.propositionDaction"
            @input="form.propositionDaction = valueTrimLeft($event)"
            @change="updateModelItem( 'propositionDaction')"
          />
        </el-form-item>
      </div>
      <div class="col-12">
        <el-form-item
          :label="L10n('action-results')"
          prop="actionResults"
          class="material-style"
        >
          <el-input
            :value="form.actionResults"
            @input="form.actionResults = valueTrimLeft($event)"
            @change="updateModelItem( 'actionResults')"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('action-results-date')"
          prop="actionResultsDate"
          class="material-style"
        >
          <date-picker
            v-model="form.actionResultsDate"
            @change="updateModelItem( 'actionResultsDate')"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('employee-signature-rq')"
          prop="employeeSignatureRQID"
          class="material-style"
        >
          <select-response
            :model.sync="form.employeeSignatureRQID"
            @update:model="updateModelItem( 'employeeSignatureRQID')"
            :isLoading="dataSourceEmployee.loading"
            :data="dataSourceEmployee.records"
            :fields="{id: 'id', title: 'name'}"
          ></select-response>
        </el-form-item>
      </div>
    </div>

    <!-- 2 -->
    <div class="row">

    </div>
    <!-- 3 -->
    <!-- 4 -->
    <!-- 5 -->
    <div class="row">
      <div class="col-md-4 col-12">

      </div>
    </div>
    <!-- 6 -->

    <!-- 7 -->
    <!-- 8 -->
    <div class="row">
      <div class="col-xl-4 col-12">
        <div class="row">

          <div class="col-4">

          </div>
          <div class="col-4">

          </div>
        </div>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormContacts',
  mixins: [Form],
  components: {
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue')
  },
  computed: {
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name&filter=isActive==true&OrderBy=name')
    },
    dataSourceNonConformityNature () {
      return this.API('NonConformityNatures/GetAllDynamic?select=id,title')
    },
    dataSourceNonConformityOrigin () {
      return this.API('NonConformityOrigins/GetAllDynamic?select=id,title')
    },
    dataSourceNonConformityDysfunction () {
      return this.API('NonConformityDysfunctions/GetAllDynamic?select=id,title')
    },
    dataSourceNonConformityDysfunctionDetail () {
      return this.API('NonConformityDysfunctionDetails/GetAllDynamic?select=id,title')
    },
    dataSourceNonConformityAction () {
      return this.API('NonConformityActions/GetAllDynamic?select=id,title')
    }
  }
}
</script>
